import { forwardRef, useEffect, useState } from "react";
import { useApp } from "../../contexts";

export const AddressTruncate = forwardRef(({
  isShowText = true,
  splitFont = 25,
  splitEnd = 5,
  numDot = 5,
  splitFontLg = 36,
  textCss='',
  ...props
}, ref) => {
  let text = props?.text || "";
  const [copied, setCopied] = useState(false);
  const { T } = useApp();
  useEffect(() => {
    let timer;
    if (copied) {
      timer = setTimeout(() => {
        setCopied(false);
      }, 1000);
    }
    return () => {
      clearTimeout(timer);
    };
  }, [copied]);

  const splitText = () => {
    let item = text;
    if (item.length >= splitFont + 10) {
      item = item.substring(0, splitFont);
      for (let i = 0; i < numDot; i++) {
        item += ".";
      }
      item += text.substring(text.length - splitEnd, text.length);
    }
    return item;
  };
  const splitTextLg = () => {
    let item = text;
    if (item.length >= splitFontLg + 5) {
      item = item.substring(0, splitFontLg);
      for (let i = 0; i < numDot; i++) {
        item += ".";
      }
      item += text.substring(text.length - splitEnd, text.length);
    }

    return item;
  };

  return (
    <div>
        {isShowText && (
          <b style={props?.textStyle || {}} className={textCss} onClick={() => props?.textAction?.()}>
            {window.innerWidth <= 500 || props.cutText ? splitText(text) : splitTextLg(text)}
          </b>
        )}
    </div>
  )
});
